import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

class MarketDeliveryRangesClient {
  static baseUrl = BASE_URL;

  static getMarketDeliveryRanges(user) {
    const url = this.baseUrl + `/market/deliveryRanges?market=${user.market}`;

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static async saveMarketDeliveryRanges(data, user) {
    const url = this.baseUrl + `/market/deliveryRanges?market=${user.market}`;

    return await axios
      .post(url, data, getHeaders(user.token))
      .then((response) => response.status)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static async disableRanges(user) {
    const url =
      this.baseUrl + `/market/deliveryRangesDisable?market=${user.market}`;

    return await axios
      .get(url, getHeaders(user.token))
      .then((response) => response.status)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}

export default MarketDeliveryRangesClient;
